module.exports = __webpack_public_path__ + "static/media/QApp.00cc63eb.png";